/**
 * Scene readiness as queryable state, not just a one-off event. Graph nodes can
 * subscribe after the scene has already loaded, and an edge they missed would
 * otherwise never reach them.
 */

export const SCENE_LOADED_EVENT = 'onSceneLoaded';

let isSceneLoaded = false;

export function hasSceneLoaded(): boolean {
  return isSceneLoaded;
}

export function markSceneAsLoaded(): void {
  isSceneLoaded = true;
  window.dispatchEvent(new Event(SCENE_LOADED_EVENT));
}

export function onSceneLoaded(listener: () => void): () => void {
  window.addEventListener(SCENE_LOADED_EVENT, listener);
  return () => window.removeEventListener(SCENE_LOADED_EVENT, listener);
}
